<template>
  <div class="page upload">
    <v-row align-content="space-between text-center">
      <v-col cols="12" sm="5">
        <div class="d-flex flex-column justify-center fill-height">
          <h2 class="mb-5">
            Create a Profile.
            <br />Get Future-Ready!
          </h2>
          <p class="mb-5">
            Let's collaborate.<br />
            Our HR experts are ready to help you ace your next interview.
          </p>
          <div class="text-center">
            <AuthModal
              buttonText="Get Started For Free"
              mobileButtonText="Apply"
              color="#FC4A46"
              dark
            />
          </div>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="7" class="pr-0 pb-0">
        <div
          class="d-flex flex-column justify-end align-center text-center fill-height"
        >
          <v-img
            class="splash-image mt-2"
            src="https://hrng-assets.s3.amazonaws.com/five_person_group_pic_28770037e5.jpg"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AuthModal from '@/components/Auth/AuthModal';
export default {
  components: { AuthModal },
};
</script>

<style></style>
